import { Modal, Button } from "antd";
import { X } from "lucide-react";

export default function RescheduleModal({
  isOpen,
  onCancel,
  onConfirm,
  imageSrc,
}) {
  return (
    <Modal
      open={isOpen}
      onCancel={onCancel}
      footer={null}
      centered
      closeIcon={<X className="w-6 h-6 text-gray-700" />}
      style={{ textAlign: "center", fontFamily: "Poppins, sans-serif",  padding: 0, backgroundColor: "rgba(55, 65, 81, 0.9)" }}
      width={420}
    >
      <img
        src={imageSrc}
        alt="Reschedule"
        className="mx-auto mb-6 w-32 h-32 object-contain"
      />

      <h2 className="text-xl font-semibold mb-4 font-poppins">
        Reschedule Appointment?
      </h2>

      <p className="text-[#334155] mb-8 text-sm font-poppins">
        We will send out a reschedule request to your client and ask them to
        book again when you're available.
      </p>

      {/* Divider */}
      <div className="w-full h-px bg-gray-200 mb-6"></div>

      <div className="flex justify-center gap-5">
        <Button
          onClick={onCancel}
          className="px-6 py-3 font-medium rounded-md font-poppins"
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          type="primary"
          className="px-6 py-3 btn-gradient text-white rounded-xl font-poppins"
        >
          Confirm
        </Button>
      </div>
    </Modal>
  );
}
